module.exports = __webpack_public_path__ + "img/1st.178651b.png";